import React, { useContext, useEffect, useState, useCallback } from "react";
import styles from "../../css/DatabaseImport.module.css";
import useTheme from "../../config/useTheme";
import ModalContext from "config/context/modalContext";
import ModalShell from "components/shared/modal/ModalShell";
import AuthenticationContext from "config/context/authenticationContext";
import { useImportRedisDatabase } from "api/database/useDatabase";
import SuccessfullActionModal from "features/permissions/components/modals/SuccessfullActionModal";
import { useNavigate } from "react-router-dom";
import ProgressModal from "features/permissions/components/modals/ProgressModal";
import PrivateKeyField from "components/shared/private-key-field/PrivateKeyField";

const RedisImport = () => {
  const navigate = useNavigate();
  const { dark } = useTheme();
  const { handleModal } = useContext(ModalContext);
  const { isPermissionValid } = useContext(AuthenticationContext);

  const [data, setData] = useState({
    private_key: "",
    redis_host: "http://127.0.0.1",
    redis_port: "6379",
    redis_password: null,
    composition: "",
  });

  const {
    response,
    loading,
    error,
    importDatabase,
    resetServerStatus
  } = useImportRedisDatabase({
    private_key: data.private_key,
    redis_host: data.redis_host,
    redis_port: data.redis_port,
    redis_password: data.redis_password,
    composition: data.composition
  });

  const clearData = () => {
    setData((prevData) => ({
      ...prevData,
      redis_host: "",
      redis_port: "",
      redis_password: "",
      composition: "",
    }));
  };

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    importDatabase();
  };

  useEffect(() => {
    if (!response?.status) return;

    setTimeout(() => {
      resetServerStatus();
      clearData();
      handleModal(false);
      navigate("/compositions?composition=" + response?.data?.compositions[0]?.name);
    }, 1600);

  }, [response]);

  if (loading) {
    return (
      <ModalShell>
        <ProgressModal loading={loading} />
      </ModalShell>
    );
  }

  if (response?.status) {
    return (
      <ModalShell>
        <SuccessfullActionModal message={response?.message} />
      </ModalShell>
    );
  }

  return (
    <ModalShell closeOnOverlay={true}>
      <div className={`${styles.modal} ${dark ? styles.dark : ''}`}>
        <div className={styles.modal_header}>
          <h2>Redis Import</h2>
        </div>
        <form onSubmit={handleSubmit} className={styles.database_import_form}>
          {isPermissionValid('active') ? (
            ""
          ) : (
            <div className={styles.form_item}>
              <p>
                Private key <span>*</span>
              </p>
              <PrivateKeyField
                name="private_key"
                value={data.private_key}
                onChange={handleChange}
              />
            </div>
          )}
          <div className={styles.form_item}>
            <p>
              Redis host <span>*</span>
            </p>
            <input
              type="text"
              name="redis_host"
              value={data.redis_host}
              onChange={handleChange}
            />
          </div>
          <div className={styles.form_item}>
            <p>
              Redis port <span>*</span>
            </p>
            <input
              type="text"
              name="redis_port"
              value={data.redis_port}
              onChange={handleChange}
            />
          </div>
          <div className={styles.form_item}>
            <p>Redis password</p>
            <input
              type="password"
              name="redis_password"
              value={data.redis_password}
              onChange={handleChange}
            />
          </div>
          <div className={styles.form_item}>
            <p>
              Composition <span>*</span>
            </p>
            <input
              type="text"
              name="composition"
              value={data.composition}
              onChange={handleChange}
            />
          </div>
          {error && <div className={styles.error_area}>
            <p>{error}</p>
          </div>}
          <div className={styles.form_submition_area}>
            <>
              <button type="submit">Import</button>
              <button type="button" onClick={() => handleModal(false)}>
                Cancel
              </button>
            </>
          </div>
        </form>
      </div>
    </ModalShell>
  );
};

export default RedisImport;
